import { useParams } from 'react-router-dom';

import { useAnnotationQueues } from '@/hooks/useSwr';

import { Breadcrumb, BreadcrumbData } from '../../components/Breadcrumbs';

export function AnnotationQueueCrumb(props: Partial<BreadcrumbData>) {
  const { annotationQueueId } = useParams();
  const { data: annotationQueues } = useAnnotationQueues({
    ids: [annotationQueueId ?? ''],
  });
  if (annotationQueues && annotationQueues.length > 0) {
    return <Breadcrumb name={annotationQueues[0].name} {...props} />;
  }
  return <Breadcrumb name="Annotation Queue" {...props} />;
}
